import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateAbsence = async ({
  projectId,
  absenceType,
  fromDate,
  toDate,
  resourceId,
  description,
}) => {
  const apiPath = `${projectId}/records/create-absence-records`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      absenceType,
      fromDate,
      toDate,
      resourceId,
      description,
    },
  });

  const response = await axios(signedRequest);

  return response.data;
};
